export default __webpack_public_path__ + "static/media/seats.f4cf0c8c.svg";